"use strict";

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

var OrganizationContactTypeSelector = React.createClass({
	propTypes: {
		childClass: React.PropTypes.string,
		context: React.PropTypes.string,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		isDesignMode: React.PropTypes.bool,
		organizationContactTypeConfig: React.PropTypes.object,
		reactComponentCategory: React.PropTypes.string,
		required: React.PropTypes.bool,
		theme: React.PropTypes.string
	},

	render: function () {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				config={this.props.organizationContactTypeConfig}
				wizard={AccountStore.get("wizardOrganizationContactTypes")}
				wizardValuesKey="contactType"
				configKey="availableContactTypes"
				reactComponentName="OrganizationContactTypeSelector"
				selectClassName="organization-contact-type-selector"
				optionsClassName="organization-contact-type"
				selectNameAttribute="organizationContactType"
			/>
		);
	}
});

module.exports = OrganizationContactTypeSelector;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/OrganizationContactTypeSelector.jsx